export const initVideos = (container = document) => {
	container.querySelectorAll('video[autoplay]').forEach(video => {
		video.play().catch(() => {})
	})
}
